import HeroSection from './components/HeroSection';
import ValuesSection from './components/ValuesSection';
import ApproachSection from './components/ApproachSection';
import ExpertiseSection from './components/ExpertiseSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <ValuesSection />
      <ApproachSection />
      <ExpertiseSection />
      <ContactSection />
    </main>
  );
}